export function openAliceChat(promptId?: number) {
    if (!promptId) {
        return;
    }

    window.open(`/prompthub/api/redirects/alice-chat?prompt=${promptId}`, '_blank', 'noopener, noreferrer');
}
